import styled from "@emotion/styled";

import { Icon } from "~/components/common/icon";
import { ContentBookmark } from "~/components/content/content-bookmark";

export const FlexContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;

  inline-size: 100%;
`;

export const VideoIcon = styled(Icon)`
  margin-inline-start: 10px;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: stretch;

  & + & {
    margin-inline-start: 20px;
  }
`;

export const StyledContentBookmark = styled(ContentBookmark)`
  inline-size: 15px;
  block-size: 15px;
  margin-inline-start: 16px;
  padding: 0;

  color: #4585ff;
`;
